import { default as MoonRating } from './moon-rating';
MoonRating();
export { MoonRating };
